import { ChangeDetectorRef, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../../../@AppService/Services/loader-service.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  loading$: Observable<boolean>;
  progress$: Observable<number>;
  constructor(
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef
  ) {
    this.loading$ = this.loadingService.loading$;
    this.progress$ = this.loadingService.progress$;
  }
  ngOnInit(): void {
    this.loadingService.loading$.subscribe((loading) => {
      this.cdr.detectChanges();
    });
  }
}
